import React from 'react';
import { useCategoryColor } from '@/hooks/useCategoryColor';

import s from './content_block.module.scss';

export default function ContentBlock({ content, post_fields }) {
  const firstCategory = post_fields?.categories[0];
  const { categoryColor } = useCategoryColor(firstCategory);

  return (
    <div
      className={`${s.root} ${s[categoryColor]}`}
      dangerouslySetInnerHTML={{
        __html: content?.replace(/<p>&nbsp;<\/p>/gim, '').replace(/style=\"font-weight: .{3};\"/gmi, '')
      }}
    />
  );
}
